/* global accountName, accountId, accountNameFromParam */

import login from './cti-app'
import Adaptors from './adaptors'
import parseInput from './input'
import { removeQueryParam, getQueryParam } from './helpers/query.string'
import { getAccountFeatureFlags } from './helpers/account-feature-flags'
import logger from './helpers/logger'

const POPOVER_HEIGHT = 300

const input = parseInput(window.location.search)
const integration = input.mode || input.integration

const error = getQueryParam('error')
if (error) {
  removeQueryParam('error')
}
const org = getQueryParam('org')

const isAccountNameFromParam = typeof accountNameFromParam !== 'undefined' ? accountNameFromParam : false

getAccountFeatureFlags(accountId, accountName, isAccountNameFromParam).then((shouldUseAccountName) => {
  Adaptors.getAdaptor(
    integration,
    null,
    [],
    {},
    {
      onBeforeVendorReady (adaptor) {
        adaptor.showPopover(POPOVER_HEIGHT)

        logger.log('[CTI-Login] Automatic login check', {
          accountNameProvided: !!accountName,
          accountIdProvided: !!accountId,
          accountNameFromParam: isAccountNameFromParam,
          shouldUseAccountName
        })

        login(
          integration,
          error,
          org,
          shouldUseAccountName ? accountName : ''
        )
      }
    },
    'electron',
    input.useGeneric
  )

  console.log('Welcome to the Azores CTI')
})
